import { api } from './auth.service';

const feriadoService = {
  // Lista feriados (filtro opcional por ano)
  listar: async (ano) => {
    const params = ano ? `?ano=${ano}` : '';
    const r = await api.get(`/feriados${params}`);
    return r.data;
  },

  criar: async (dados) => {
    const r = await api.post('/feriados', dados);
    return r.data;
  },

  atualizar: async (id, dados) => {
    const r = await api.put(`/feriados/${id}`, dados);
    return r.data;
  },

  excluir: async (id) => {
    const r = await api.delete(`/feriados/${id}`);
    return r.data;
  },

  // Importar feriados de um ano (calcula Páscoa e gera nacionais + Curitiba)
  importarAno: async (ano, usuarioId) => {
    const r = await api.post('/feriados/importar', { ano, usuario_id: usuarioId });
    return r.data;
  },
};

export default feriadoService;
